<template>
  <QuestionForm
    v-if="show"
    class="question-page"
    ref="questionForm"
    :formLine="questionFormLine"
    :data="questionData"
  />
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import QuestionForm from '@/components/mobile/questionFrom.vue'
import { QUESTION_TYPE as OPEN_QUESTION_TYPE } from '@/constant/openQuestion'
import mixin from './mixin'
import { validateIDCardNumberByVant } from '@/utils/validator'
import { STEP_TYPE } from '@/constant/candidate'

export default {
  mixins: [mixin],
  components: {
    QuestionForm
  },
  props: {
    data: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      questionFormLine: [],
      questionData: {},
      isElcCompany: false
    }
  },
  computed: {
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    ...mapActions('candidate', ['getJobQuestion', 'saveJobQuestion']),
    formatQuestionLine (question) {
      const questionData = {}
      const uploaderFileSize = 200 * 1024 * 1024
      const uploaderFileTypeList = ['video/mp4', 'video/x-msvideo', 'video/ogg', 'video/quicktime']
      this.questionFormLine = _.map(question, item => {
        let elType = item.type
        const result = item.result

        const line = {
          id: item.id,
          title: item.title.replace(/[\n]+$/, ''),
          type: item.type,
          name: `question-${item.id}`,
          fileSize: uploaderFileSize,
          maxSize: 1,
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
        }

        let data = ''
        if (elType === OPEN_QUESTION_TYPE.VIDEO) {
          data = {
            videoKey: result?.video_resource_key,
            description: result?.value
          }
          line.fileType = uploaderFileTypeList
          if (this.isElcCompany) {
            line.capture = 'camera'
            line.fileType = 'video/*'
            line.byCamera = true
          }
          line.elType = 'file'
          line.duration = item.duration
          line.tips = [
            this.$t(`${this.i18nPrefix}.message.uploadTip.${this.isElcCompany ? 'videoUploadTipsForELC' : 'videoUploadTips'}`),
            this.$t(`${this.i18nPrefix}.message.uploadTip.openQuestionVideo`, { duration: item.duration })
          ]
          line.btnName = this.$t(`${this.i18nPrefix}.btn.upload.selectFile`)
          line.placeholder = this.$t(`${this.i18nPrefix}.placeholder.videoDescription`)
        } else if (elType === OPEN_QUESTION_TYPE.ATTACHMENT) {
          data = {
            videoKey: result?.video_resource_key,
            description: result?.value
          }

          line.elType = 'file'
          line.tip = this.$t(`${this.i18nPrefix}.message.uploadTip.attachment`, { size: 200 })
          line.btnName = this.$t(`${this.i18nPrefix}.btn.upload.selectFile`)
          line.placeholder = this.$t(`${this.i18nPrefix}.placeholder.fileDescription`)
        } else if (elType === OPEN_QUESTION_TYPE.SELECT) {
          elType = 'radio'
          data = parseInt(result?.value)

          line.elType = 'radio'
          line.options = {
            data: item.option,
            labelKey: 'description',
            valueKey: 'id'
          }
        } else if (elType === OPEN_QUESTION_TYPE.CHECKBOX) {
          data = result?.options

          line.elType = 'checkbox'
          line.options = {
            data: item.option,
            labelKey: 'description',
            valueKey: 'id'
          }
        } else if (elType === OPEN_QUESTION_TYPE.TEXT) {
          data = result?.value

          line.elType = 'question-text'
          line.autosize = { minHeight: 46 }
          if (item.is_id_number) {
            line.autosize = { minHeight: 24 }
            line.rows = '1'
            line.rules.push({ validator: this.validateIDCardNumber, message: this.$t('common.message.invalidIDCardNumber'), trigger: 'onBlur' })
          }
        } else if (elType === OPEN_QUESTION_TYPE.DATE) {
          data = result?.value
          line.type = 'text'
          line.elType = 'date'
          line.dateType = 'date'
        }
        questionData[`question-${item.id}`] = data
        return line
      })
      this.questionData = questionData
    },
    validateIDCardNumber (value, rule) {
      const result = validateIDCardNumberByVant(value)
      if (result.msg) {
        rule.message = result.msg
      }
      return result.valid
    },
    getAnswer () {
      const answer = {}
      _.forEach(this.questionFormLine, line => {
        const questionId = line.id
        const name = line.name
        let questionAnswer = this.questionData[name]
        if (line.type === OPEN_QUESTION_TYPE.CHECKBOX) {
          questionAnswer = questionAnswer.toString()
        } else if (line.type === OPEN_QUESTION_TYPE.ATTACHMENT || line.type === OPEN_QUESTION_TYPE.VIDEO) {
          questionAnswer = {
            videoKey: questionAnswer.videoKey,
            description: questionAnswer.description || null
          }
        }
        answer[questionId] = questionAnswer
      })
      return answer
    },
    async submit () {
      const form = await this.getForm()
      if (!form) {
        return false
      }
      const result = await form.submit()
      return result
    },
    customValid () {

    },
    async getForm () {
      if (this.show) {
        let form = this.$refs.questionForm
        if (!form) {
          await this.$nextTick()
          form = this.$refs.questionForm
        }
        return form
      }
      return null
    }
  },
  watch: {
    data: {
      immediate: true,
      handler () {
        this.isElcCompany = this.resumeEditorSetting?.[STEP_TYPE.JOB_QUESTIONNAIRE].isElcCompany
        if (this.data) {
          this.formatQuestionLine(this.data)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
